/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AttachmentResponse } from 'src/app/shared/models/i-attachment-response.modal';
import { IAttachment } from 'src/app/shared/models/i-attachment.modal';
import { PrecastService } from 'src/app/shared/services/precast.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messagesConfig } from 'src/app/shared/constants/message.constants';
import { CustomSnackMessageComponent } from 'src/app/shared/components/customsnackmessage/customsnackmessage.component';
import { UserService } from 'src/app/shared/services/user.service';
import { AccountInfo } from '@azure/msal-browser';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CameraCaptureComponent } from 'src/app/features/dashboard/components/camera-capture/camera-capture.component';
import { WorksheetService } from 'src/app/features/worksheet/services/worksheet.service';
import { FormService } from '../../services/form.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-customer-attachments',
    templateUrl: 'customer-attachments.component.html',
    styleUrls: ['customer-attachments.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerAttachmentsComponent implements OnInit {
  @Input() projectId: string | null;
  @Input() backgroundClass: string;
  @Input() showDrawerLink = true;
  @Output() selectedAttachment: EventEmitter<IAttachment> = new EventEmitter();
  selectedFiles: File[] = [];
  attachedFiles: AttachmentResponse[] = [];
  displayAddColumns: string[] = ['fileName', 'deleteAttachment'];
  displayStoreColumns: string[] = ['fileName', 'downloadStoredAttachment', 'deleteStoredAttachment'];
  dataSource = new MatTableDataSource<File>();
  dataSourceAttached = new MatTableDataSource<AttachmentResponse>();
  totalFileSize = 0;
  isSuccess: boolean;
  account: AccountInfo | null;

  allowedFormat = 'application/pdf, image/jpeg, image/png, image/jpg, text/plain';
  allowedFallbackExtensions = '.db';
  fileURL = '';
  fileTypeExtension = '';
  urlBlob = '';
  fileName = '';
  projectName: string;
  projectNumber: string;
  @Input() set showSuccess(value: boolean) {
    this.isSuccess = value;
  }

  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('drawer') drawer: any;

  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    public precastService: PrecastService,
    public snackBar: MatSnackBar,
    public userService: UserService,
    private formService: FormService,
    private router: Router,
    private worksheetService: WorksheetService,
  ) {
    this.userService.userAccount?.subscribe({
      next: (userAccount) => {
        this.account = userAccount;
      },
    });
  }

  ngOnInit(): void {
    this.formService.attachments.subscribe({
      next: (files: File[] | null) => {
        if (files) {
          this.selectedFiles = [...files];
          this.dataSource.data = this.selectedFiles;
          this.emitSelectedAttachment();
        } else {
          this.selectedFiles = [];
        }
      },
    });
    this.getAllAttachment();
    this.checkSessionStorageFile();
  }

  openDrawer(projectID: string) {
    this.projectId = projectID;
    this.ngOnInit();
    this.drawer.open();
  }

  openCamera(): void {
    const dialogRef = this.dialog.open(CameraCaptureComponent, {
      panelClass: 'camera-fullscreen-dialog',
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      backdropClass: 'camera-backdrop',
      data: {
        projectID: this.projectId, projectName: this.projectName, sampleID: '',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getAllAttachment();
    });
  }

  /** Start - email attchement section only used this function */
  checkSessionStorageFile() {
    const storedFile = sessionStorage.getItem('uploadedFile');
    if (storedFile) {
      const uploadedFileInfo = JSON.parse(storedFile);
      const byteCharacters = atob(uploadedFileInfo.content.split(',')[1]);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: 'application/pdf',
      });
      const file = new File([blob], uploadedFileInfo.filename);
      this.totalFileSize = file.size;
      this.selectedFiles.push(file);
      this.emitSelectedAttachment();
      this.dataSource.data = this.selectedFiles;
    }
  }
  /** End - email attchement section only used this function */

  deleteAttachment(index: number) {
    const deletedFile = this.selectedFiles.splice(index, 1)[0];
    this.totalFileSize -= deletedFile.size;
    this.dataSource.data = this.selectedFiles;
    this.formService.attachments.next(this.selectedFiles);
  }

  getFileDetails(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      for (let i = 0; i < inputElement.files.length; i++) {
        const file = inputElement.files[i];
        const extension = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
        if (this.isValidFile(file) || extension === file.name.toLocaleLowerCase()) {
          this.totalFileSize += file.size;
          this.selectedFiles.push(file);
        }
      }

      if (inputElement.files.length > this.selectedFiles.length) {
        this.snackBar.openFromComponent(CustomSnackMessageComponent, {
          data: messagesConfig.customerAttachmentError.message,
          duration: 5000,
          verticalPosition: 'top',
          panelClass: ['red-snackbar'],
        });
      }

      this.emitSelectedAttachment();
      this.formService.attachments.next(this.selectedFiles);
      this.dataSource.data = this.selectedFiles;
    }
    this.fileInput.nativeElement.value = '';
  }

  clearSelection() {
    this.selectedFiles = [];
    this.totalFileSize = 0;
    this.dataSource.data = [];
    sessionStorage.removeItem('selectedFiles');
  }

  getAttachment(fileResponse: AttachmentResponse, download: boolean) {
    if (!this.projectId) return;
    this.precastService.getAttachement(this.projectId, fileResponse.fileName).subscribe({
      next: (response) => {
        const { url } = response || {
        };
        if (!download) {
          window.open(url, '_blank');
        } else {
          this.downloadFile(url);
        }
      },
    });
  }

  previewAttachment(fileResponse: AttachmentResponse) {
    if (!this.projectId) return;
    const isTestData = this.getFileExtension(fileResponse.fileName).toLowerCase() === 'db';
    const urlTree = isTestData
      ? this.router.createUrlTree(['/preview-test-data'], {
        queryParams: {
          projectId: this.projectId,
          fileName: fileResponse.fileName,
        },
      })
      : this.router.createUrlTree(['/preview-attachments', this.projectId, fileResponse.fileName]);
    window.open(this.router.serializeUrl(urlTree), '_blank');
  }

  getAllAttachment() {
    if (!this.projectId) return;
    this.worksheetService.fetchProjectById(this.projectId).subscribe({
      next: (project) => {
        this.projectName = project.projectName;
        this.projectNumber = project.projectNumber;
      },
    });
    this.precastService.getAllattachments(this.projectId, false).subscribe({
      next: (response) => {
        this.attachedFiles = response || [];
        this.dataSourceAttached.data = this.attachedFiles;
      },
    });
  }

  deleteStoredAttachment(file: AttachmentResponse) {
    this.dialog.open(ConfirmationDialogComponent, {
      width: '360px',
      data: {
        title: 'Delete Attachment',
        content: 'Are you sure you want to delete this attachment?',
        cancelText: 'NO',
        continueText: 'YES',
      },
      disableClose: true,
    }).afterClosed().subscribe((confirmed: string) => {
      if (confirmed !== 'YES') return;

      if (!this.projectId) return;
      this.precastService.deleteAttchment(this.projectId, file.fileName).subscribe({
        next: () => {
          this.getAllAttachment();
          this.snackBar.openFromComponent(CustomSnackMessageComponent, {
            data: messagesConfig.deleteFileMessage.message,
            duration: 3000,
            verticalPosition: 'top',
            panelClass: ['default-snackbar'],
          });
        },
      });
    });
  }

  uploadByManager() {
    if (!this.projectId) return;
    const formData = new FormData();
    this.selectedFiles.forEach((file, index) => {
      formData.append(`file_${index}`, file, file.name);
    });
    this.precastService.uploadAttachments(this.projectId, formData, true).subscribe({
      next: () => {
        this.clearSelection();
        this.getAllAttachment();
        this.snackBar.openFromComponent(CustomSnackMessageComponent, {
          data: messagesConfig.apiUploadSuccessMessage.message,
          duration: 3000,
          verticalPosition: 'top',
          panelClass: ['default-snackbar'],
        });
        this.formService.attachments.next([]);
      },
    });
  }

  isValidFile(file: File): boolean {
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg', 'text/plain'];
    const maxSize = 10 * 1024 * 1024;
    const isFileTypeValid = allowedTypes.includes(file.type);

    const extension = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
    const isFallbackExtensionValid = this.allowedFallbackExtensions.includes(extension);
    if (this.totalFileSize + file.size >= maxSize) {
      this.snackBar.openFromComponent(CustomSnackMessageComponent, {
        data: messagesConfig.customerAttachmentError.message,
        duration: 5000,
        verticalPosition: 'top',
        panelClass: ['red-snackbar'],
      });
      return false;
    }
    const isNotDuplicate = !this.attachedFiles.some((attachedFile) => attachedFile.fileName === file.name)
      && !this.selectedFiles.some((selectedFile) => selectedFile.name === file.name);
    return (isFileTypeValid || isFallbackExtensionValid) && isNotDuplicate;
  }

  emitSelectedAttachment() {
    const formData = new FormData();
    this.selectedFiles.forEach((file) => formData.append('files', file));
    this.selectedAttachment.emit({
      value: formData,
      dirty: true,
      valid: this.selectedFiles.length > 0,
    });
  }

  formatSize(size: number): string {
    if (size > 1024 * 1024 || size === 1024 * 1024) {
      return `${(size / (1024 * 1024)).toFixed(1)} MB`;
    }
    if (size > 1024 || size === 1024) {
      return `${(size / 1024).toFixed(1)} KB`;
    }
    return `${size} byte`;
  }

  private downloadFile(saasUrl: string) {
    const fileName = this.extractFileNameFromUrl(saasUrl);
    const options = {
      responseType: 'blob' as const,
      observe: 'response' as const,
    };

    this.http.get(saasUrl, options).subscribe({
      next: (response: HttpResponse<Blob>) => {
        if (response.body) {
          const blob = new Blob([response.body]);
          const a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = fileName;
          a.click();
        }
      },
    });
  }

  private extractFileNameFromUrl(saasUrl: string): string {
    const urlParts = saasUrl.split('/');
    let fileNameWithQuery = urlParts[urlParts.length - 1];

    if (fileNameWithQuery.includes('?')) {
      fileNameWithQuery = fileNameWithQuery.split('?')[0];
    }

    return fileNameWithQuery || 'default-filename.txt';
  }

  getFileExtension(filename: string): string {
    return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2);
  }
}
